import { Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import ButtonLink from "../../common/buttonLink";
import FormDialog from "../../common/formDialog";
import PagingAndSorting from "../../common/pagingAndSorting";

import FeeItemForm from "./feeItemForm";
import FeeItemTable from "./feeItemTable";
import feeItemService from "../../../services/feeItemService";
import logger from "../../../services/logger";
import Add from "../../common/add";

class FeeItems extends PagingAndSorting {
  state = {
    institutes: [],
    sortColumn: { path: "id", order: "asc" },
    page: 0,
    rowsPerPage: 10,
    confirmDialogOpen: false,
    dialogOpen: false
  };

  getAll = async () => {
    try {
      const { data } = await feeItemService.getAllByCategoryId(this.props.categoryId);
      this.setState({ data });
    } catch (ex) {
      logger.error(ex);
    }
  };

  deleteById = async (id) => {
    try {
      await feeItemService.deleteById(id);
      await this.getAll();
    } catch (ex) {
      logger.error(ex);
    }
  };

  componentDidMount() {
    this.getAll();
  }

  
  closeDialog = () => {
   
    this.setState({ dialogOpen: false });
    this.getAll();
  };
  onConfirmOk = async (id) => {
    try {
      await feeItemService.deleteById(id);
      await this.getAll();
    } catch (ex) {
      logger.error(ex);
    }
  };

  render() {
    const { sortColumn, data,dialogOpen,id } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        <Grid container>
          <Grid container item sm={12} md={12} lg={12} direction="row-reverse">

            <Add onAdd={this.handleAdd} item={{id:"new"}} icon="add_circle" title={t("Add Fee Item")}/>

          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            &nbsp;
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FeeItemTable
              data={data}
              sortColumn={sortColumn}
              onSort={this.handleSort}
              onDelete={this.handleDelete}
              onEdit={this.handleEdit}
            />
          </Grid>
        </Grid>
        {this.renderDeleteConfirmDialog(
          "Delete Confirmation",
          "Are you sure you want to delete?"
        )}

        {dialogOpen && (
          <FormDialog
            id="education-dialog"
            keepMounted
            title={"Add or Update"}
            content={
              <FeeItemForm                 
                id={id ? id : "new"}
                categoryId={this.props.categoryId}
                onSave={this.closeDialog}
              />
            }
            open={dialogOpen}
            onClose={() => this.setState({ dialogOpen: false })}
          />
        )}
      </React.Fragment>
    );
  }
}

export default withTranslation(["feeItem"])(FeeItems);
